import React from "react";
import { Table, TableBody, TableCell, TableRow, TableContainer, TableHead, Paper, tableCellClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Strings } from "../../resources/i18n/i18n";

// Styled TableCell
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 10,
        backgroundColor: "#d5d5d5",
        color: theme.palette.common.black,
        fontWeight: 'bold',
        borderRight: "1px solid #bbb",
        padding: '8px',
        position: 'sticky',
        top: 0,
        zIndex: 1,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 10,
        borderRight: "1px solid #bbb",
        padding: '8px',
        overflow: "hidden",
    }
}));

// KeyValueTable Component
const KeyValueTable = ({ data, columns, title }) => {

    if (!data || Object.keys(data).length === 0) {
        return (
            <div className='noRecordsFound noBranchRecords'>
                {Strings("NoRecordsFound")}
            </div>
        );
    }

    // Flatten nested JSON strings if any
    const flattenValue = (value) => {
        if (typeof value === "string") {
            try {
                const parsed = JSON.parse(value);
                if (typeof parsed === "object") {
                    return JSON.stringify(parsed, null, 2);
                }
            } catch (e) {
                return value;
            }
        }
        if (typeof value === "object" && value !== null) {
            return JSON.stringify(value, null, 2);
        }

        if (typeof value === "boolean") {
            return value ? "true" : "false";
        }
        return value !== null && value !== undefined ? value : "-";
    };

    return (
        <div className='d-flex justify-content-center mx-2 pt-2 pb-3' style={{ maxHeight: "25em" }}>
            <TableContainer component={Paper} sx={{ border: "1px solid #ccc", width: "100%" }}>
                <Table>
                    {/* Table Header */}
                    <TableHead>
                        <TableRow>
                            <StyledTableCell style={{ fontWeight: "bold", width: "10%" }}>
                                {Strings("Field")}
                            </StyledTableCell>
                            <StyledTableCell style={{ fontWeight: "bold", width: "90%" }}>
                                {Strings("Data")}
                            </StyledTableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {columns.map((col, index) => (
                            <TableRow key={index} hover>
                                <StyledTableCell style={{ fontWeight: "bold", width: "10%" }}>
                                    {col.label}
                                </StyledTableCell>
                                <StyledTableCell style={{ width: "90%", whiteSpace: "pre-wrap" }}>
                                    {flattenValue(data[col.key])}
                                </StyledTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default KeyValueTable;
